import React from 'react'
import { INewCaptureInfo } from '../../types'
import CaptureInfoManager from './manager'
import SectionButtons from './section-buttons'
import Sections from './sections'

type Props = {
    className?: string
    captureInfo?: INewCaptureInfo
    uploadProgress?: number
    isUploading?: boolean
    saveLabel: string
    onSave: (info: INewCaptureInfo) => void
    onUpdate?: (hasChanges: boolean, info: INewCaptureInfo) => void
    onCancel: () => void
    isEditMode?: boolean
}

const CreationCaptureInfo = ({
    className,
    captureInfo,
    uploadProgress,
    isUploading = false,
    saveLabel,
    onSave,
    onUpdate,
    onCancel,
    isEditMode,
}: Props) => {
    return (
        <CaptureInfoManager
            {...{
                defaultTitle: captureInfo?.title,
                defaultTags: captureInfo?.tags,
                defaultUsername: captureInfo?.username,
                defaultWatermark: captureInfo?.watermark,
                defaultWatermarkPosition: captureInfo?.watermarkPosition,
                defaultFont: captureInfo?.font,
                defaultPreviousFonts: captureInfo?.font ? [captureInfo?.font] : undefined,
                defaultSourceUrl: captureInfo?.sourceUrl,
                defaultRating: captureInfo?.rating,
                defaultIsPublic: captureInfo?.isPublic,
                defaultHasAutoCaption: captureInfo?.hasCaptions,
                defaultSegmentationType: captureInfo?.segmentationType,
                onUpdate,
            }}
        >
            <Sections className={className} isEditMode={isEditMode} />
            <SectionButtons
                {...{
                    className: className,
                    defaultLabel: saveLabel,
                    uploadProgress: uploadProgress,
                    isUploading: isUploading,
                    defaultOnSave: onSave,
                    defaultOnCancel: onCancel,
                    isEditMode: isEditMode,
                }}
            />
        </CaptureInfoManager>
    )
}

export default CreationCaptureInfo
